
import { defineComponent, onMounted } from 'vue';
import { AppFormRow, AppInput, AppButton, AppCard } from '@/components';
import useGiftSetting from '@/modules/gift/model/setting';
import { ROUTE_NAME_GIFT } from '@/modules/gift/router';

export default defineComponent({
    name: ROUTE_NAME_GIFT.SETTING,
    components: { AppFormRow, AppInput, AppButton, AppCard },
    setup() {
        const { model, v$, update, fetch } = useGiftSetting();

        onMounted(async () => {
            await fetch();
        });

        return { v$, model, update };
    }
});
